import React from 'react';

const STEPS = ['driver_assigned', 'arrived', 'started', 'completed'];
const LABEL_KEYS = {
  driver_assigned: 'trip.stepPickup',
  arrived: 'trip.stepArrived',
  started: 'trip.stepTrip',
  completed: 'trip.stepDone',
};

export default function TripProgress({ status, t }) {
  let currentIdx = STEPS.indexOf(status);
  if (currentIdx < 0) currentIdx = 0;

  return (
    <div className="dash-stepper-row" aria-label={t('trip.progressLabel')}>
      {STEPS.map((key, i) => (
        <div
          key={key}
          className={`dash-stepper-tab ${i <= currentIdx ? 'done' : ''} ${i === currentIdx ? 'active' : ''}`}
        >
          {`${i + 1}. ${t(LABEL_KEYS[key])}`}
        </div>
      ))}
    </div>
  );
}
